import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/department/employee`;

export default {
  options(payload) {
    payload.order = 'name';
    payload.sort = 'asc';
    return Client.get(`${resource}/find/option`, {
      params: payload
    });
  },
  addEmployee(payload) {
    return Client.post(`${resource}/create`, payload);
  },
  destroyEmployee(departmentId, employeeId) {
    return Client.delete(
      `${resource}/delete/${departmentId}/${employeeId}`
    );
  }
};
